import {
  State,
  VectorTile as VectorTileSource,
} from "../../../../reactOL/source";
import { useEffect, useState } from "react";
import MVT from "ol/format/MVT";
import VectorTile from "../../../../reactOL/layers/VectorTile";
import { useViewContext } from "../../../../../context/View/ViewContext";
import { GbCensusDefaultStyle } from "./LayerStyle";
import useGetCensusParams from "../controls/GetCensusParams";

interface CensusVectorTileLayerProps {
  visible: boolean;
}

const GbCensusVectorTileLayer = ({ visible }: CensusVectorTileLayerProps) => {
  const { year, outputAreaId } = useGetCensusParams();
  const { projection, tileGrid, setLoading } = useViewContext();

  const [censusTileSource] = useState(
    VectorTileSource({
      url: `https://d2l9x7mcd1amd3.cloudfront.net/2011/0/{z}/{x}/{y}.mvt`,
      onStateChange: (state: State) => setLoading(state === State.Loading),
      authorizationToken: ``,
      projection: projection,
      format: new MVT(),
      tileGrid: tileGrid,
    }),
  );

  const buildUrl = (year: number, outputAreaId: number) => {
    return `https://d2l9x7mcd1amd3.cloudfront.net/${year}/${outputAreaId}/{z}/{x}/{y}.mvt`;
  };

  useEffect(() => {
    if (year && outputAreaId != null) {
      const url = buildUrl(year, outputAreaId);
      censusTileSource.setUrl(url);
    }
  }, [year, outputAreaId]);

  return (
    <>
      <VectorTile
        source={censusTileSource}
        style={GbCensusDefaultStyle}
        zIndex={8000}
        visible={visible && outputAreaId != null}
      />
    </>
  );
};

export default GbCensusVectorTileLayer;
